<template>
  <el-card shadow="never">
    <el-page-header @back="goBack" :content="componentName"> </el-page-header>
    <el-divider></el-divider>
    <!-- 表单 -->
    <!-- 修改服务商信息 -->
    <product-operator
      ref="formOperatorInfo"
      :defaultSelector="defaultSelectorOperator"
      :showDialogOperatorInfo.sync="showDialogOperatorInfo"
      @choiceProductOperator="choiceProductOperator"
      @confirmAddOperator="confirmAddOperator"
      :spu_id="spu_id"
    ></product-operator>
    <el-form ref="formNewCoach" :model="formNewCoach" label-width="100px">
      <!-- 课程名称 -->
      <el-form-item label="教练名称">
        <el-input
          style="width: 20%"
          size="mini"
          v-model="formNewCoach.coach_name"
        ></el-input>
      </el-form-item>
      <!-- 俱乐部 -->
      <!-- <el-form-item label="所属俱乐部">
        <el-autocomplete
          :clearable="true"
          class="inline-input"
          style="width: 20%"
          :fetch-suggestions="querySearch"
          @select="handleSelect"
          size="mini"
          v-model="formNewCoach.operator_name"
        ></el-autocomplete>
      </el-form-item> -->
      <!-- 所属俱乐部 -->
      <el-form-item label="所属俱乐部">
        <el-button size="mini" @click="selectOperator">{{
          selectOperatorName
        }}</el-button>
      </el-form-item>
      <!-- 教练头像 -->
      <el-form-item label="上传教练头像">
        <up-load
          @getImageURl="getAvatorURl"
          default_image="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"
        ></up-load>
      </el-form-item>
      <!-- 封面 -->
      <el-form-item label="上传教练签名">
        <up-load accept_format=".png" @getImageURl="getImageURl"></up-load>
      </el-form-item>

      <!-- 简介 -->
      <el-form-item label="教练简介">
        <el-input
          style="width: 40%"
          type="textarea"
          v-model="formNewCoach.coach_infor"
        ></el-input>
      </el-form-item>

      <!-- 提交表单 -->
      <el-form-item>
        <el-button size="mini" type="primary" @click="onSubmitNewCoach"
          >立即创建</el-button
        >
        <el-button size="mini">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import UpLoad from "../../components/common/other/UpLoad";
import { tpx_app } from "../../network/request";
import ProductOperator from "../../components/product/ProductOperator";
export default {
  name: "creat-new-coach",
  components: {
    "up-load": UpLoad,
    ProductOperator,
  },
  data() {
    return {
      formNewCoach: {},
      spu_id: 0,
      defaultSelectorOperator: 2,
      showDialogOperatorInfo: false,
      selectOperatorName: "选择俱乐部",
      componentName: "添加教练",
      operator_list: [],
    };
  },
  mounted() {
    tpx_app({
      url: "/product/get_operator_list",
    }).then((res) => {
      const { errno, data } = res.data;
      if (errno == "0") {
        data.forEach((item) => {
          let i = {
            id: item.operator_id,
            value: item.operator_name,
          };
          this.operator_list.push(i);
        });
        // this.operator_list = data;
        // console.log(this.operator_list);
      }
    });
  },
  methods: {
    // 选择服务商按钮
    selectOperator() {
      this.showDialogOperatorInfo = true;
    },
    // 添加一个服务商
    confirmAddOperator(value) {
      this.$http.post("/product/add_operator_info", value).then((res) => {
        const { errno, errmsg } = res.data;
        if (errno == "0") {
          this.$notify({
            title: "成功",
            message: errmsg,
            type: "success",
          });
          this.$refs.formOperatorInfo.select_operator_model = 2;
          this.$refs.formOperatorInfo.selectOperatorModel();
        } else if (errno == "4103") {
          this.$notify({
            title: "警告",
            message: errmsg,
            type: "warning",
          });
        }
      });
    },
    //  列表中选择一个服务商
    choiceProductOperator(index, operator) {
      console.log(operator.operator_name);
      this.formNewCoach.operator_name = operator.operator_name;
      this.formNewCoach.operator_id = operator.operator_id;
      this.selectOperatorName = this.formNewCoach.operator_name;
      this.showDialogOperatorInfo = false;
    },
    onSubmitNewCoach() {
      console.log(this.formNewCoach);
      tpx_app({
        url: "/add_course_coach",
        method: "POST",
        data: this.formNewCoach,
      }).then((res) => {
        const { errno, errmsg } = res.data;
        if (errno == "0") {
          this.$notify({
            title: "成功",
            message: errmsg,
            type: "success",
          });
          this.$router.push({
            name: "course",
          });
        } else {
          this.$notify({
            title: "警告",
            message: errmsg,
            type: "warning",
          });
        }
      });
    },
    //   上一页
    goBack() {
      this.$router.push({
        name: "course",
      });
    },
    handleSelect(value) {
      this.formNewCoach.operator_id = value.id;
    },
    getAvatorURl(value) {
      this.formNewCoach.coach_avatar = value;
    },
    getImageURl(value) {
      this.formNewCoach.coach_signature = value;
    },
    // 自动匹配章
    querySearch(queryString, cb) {
      let operator_list = this.operator_list;
      let results = queryString
        ? operator_list.filter(this.createFilter(queryString))
        : operator_list;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (operator_list) => {
        return (
          operator_list.value
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
  },
};
</script>

<style>
</style>